import React, { useMemo } from 'react';
import { X } from 'lucide-react';
import { Button } from 'common/components';
import { CallAnalyticsMultiSelectFilter } from '../CallAnalytics/CallAnalyticsFilters';
import { CALL_ANALYTICS_DIRECTION_OPTIONS } from '../CallAnalytics/CallAnalyticsFilters/CallAnalyticsFilters.constants';
import { LIVE_MONITOR_STATUS_OPTIONS } from './liveMonitor.constants';

import styles from './LiveMonitorFilters.module.scss';

export type LiveMonitorFilterName = 'callStatus' | 'leadStatus' | 'callDirection';

export interface LiveMonitorFiltersProps {
    filterCallStatus: string;
    filterLeadStatus: string;
    filterCallDirection: string;
    partyStages?: string[];
    onFilterChange: (filter: LiveMonitorFilterName, value: string) => void;
    onClear: () => void;
}

export const LiveMonitorFilters: React.FC<LiveMonitorFiltersProps> = ({
    filterCallStatus,
    filterLeadStatus,
    filterCallDirection,
    partyStages = [],
    onFilterChange,
    onClear,
}) => {
    const partyStageOptions = useMemo(
        () => partyStages.map((stage) => ({ value: stage, label: stage })),
        [partyStages]
    );

    const hasActiveFilters = Boolean(filterCallStatus || filterLeadStatus || filterCallDirection);

    return (
        <div className={styles.filterBar} data-testid='live-monitor-filters'>
            <CallAnalyticsMultiSelectFilter
                label='Call direction'
                allOptionLabel='All directions'
                options={[...CALL_ANALYTICS_DIRECTION_OPTIONS]}
                selectedValues={filterCallDirection ? filterCallDirection.split(',').filter(Boolean) : []}
                onChange={(values) => onFilterChange('callDirection', values.join(','))}
                isMulti
            />
            <CallAnalyticsMultiSelectFilter
                label='Call status'
                allOptionLabel='All active statuses'
                options={LIVE_MONITOR_STATUS_OPTIONS}
                selectedValues={filterCallStatus ? filterCallStatus.split(',').filter(Boolean) : []}
                onChange={(values) => onFilterChange('callStatus', values.join(','))}
                isMulti
            />
            <CallAnalyticsMultiSelectFilter
                label='Party status'
                allOptionLabel='All party statuses'
                options={partyStageOptions}
                selectedValues={filterLeadStatus ? filterLeadStatus.split(',').filter(Boolean) : []}
                onChange={(values) => onFilterChange('leadStatus', values.join(','))}
                isMulti
            />
            {hasActiveFilters ? (
                <Button
                    variant='ghost'
                    size='sm'
                    icon={X}
                    onClick={onClear}
                    className={styles.clearButton}
                    aria-label='Clear filters'
                >
                    Clear
                </Button>
            ) : null}
        </div>
    );
};
